module.exports = __webpack_public_path__ + "img/about.782d9d8f.svg";